var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.dashboards),function(dashboard){return _c('li',{key:dashboard},[_c('RouterLink',{attrs:{"to":{name: dashboard}}},[_vm._v(" "+_vm._s(_vm.formatTitle(dashboard.replace(/-/gi, ' ')))+" ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }